import { render, staticRenderFns } from "./IpotekAkitTablosuAlacakFormWizard.vue?vue&type=template&id=20c1f25f"
import script from "./IpotekAkitTablosuAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./IpotekAkitTablosuAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports